import { render, staticRenderFns } from "./integrations.vue?vue&type=template&id=0f97f687&scoped=true"
import script from "./integrations.vue?vue&type=script&lang=js"
export * from "./integrations.vue?vue&type=script&lang=js"
import style0 from "./integrations.vue?vue&type=style&index=0&id=0f97f687&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f97f687",
  null
  
)

export default component.exports